import React from 'react';
import PropTypes from 'prop-types';
var ProgressBar = function ProgressBar(_ref) {
  var currentStep = _ref.currentStep,
    totalSteps = _ref.totalSteps;
  var items = [];
  var margin = 3;
  var percentWidth = 100 / totalSteps;
  for (var i = 1; i <= totalSteps; i += 1) {
    var isDone = i <= currentStep;
    var isCurrent = i === currentStep;
    items.push(/*#__PURE__*/React.createElement("div", {
      className: "progress-bar__block\n      ".concat(isDone ? 'progress-bar__block--active' : '', "\n      ").concat(isCurrent ? 'progress-bar__block--current' : '', "\n      "),
      key: i,
      style: {
        width: "calc(".concat(percentWidth, "% - ").concat(margin, "px)")
      }
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "progress-bar"
  }, /*#__PURE__*/React.createElement("div", {
    className: "progress-bar__blocks"
  }, items));
};
ProgressBar.propTypes = {
  currentStep: PropTypes.number.isRequired,
  totalSteps: PropTypes.number.isRequired
};
export default ProgressBar;